(() => {
  const loader = document.currentScript;
  const scriptUrl = loader?.dataset.photoswipeScript;
  const stylesUrl = loader?.dataset.photoswipeStyles;
  let libraryPromise;

  const loadStyles = () => {
    if (!stylesUrl || document.querySelector(`link[href="${stylesUrl}"]`)) return;
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = stylesUrl;
    document.head.appendChild(link);
  };

  const loadLibrary = () => {
    if (window.FoxTheme?.PhotoSwipe && window.FoxTheme?.PhotoSwipeLightbox) {
      return Promise.resolve();
    }
    if (libraryPromise) return libraryPromise;

    loadStyles();
    libraryPromise = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = scriptUrl;
      script.onload = resolve;
      script.onerror = reject;
      document.head.appendChild(script);
    });
    return libraryPromise;
  };

  const initialize = async (gallery) => {
    if (gallery.dataset.zoomInitialized === 'true') return;
    if (gallery.zoomInitialization) return gallery.zoomInitialization;

    gallery.zoomInitialization = Promise.all([
      customElements.whenDefined('media-gallery'),
      loadLibrary()
    ]).then(() => {
      if (gallery.dataset.zoomInitialized === 'true') return;
      gallery.dataset.enableImageZoom = 'true';
      gallery.enableImageZoom = true;
      if (gallery.elements) gallery.initImageZoom();
      gallery.dataset.zoomInitialized = 'true';
    });
    return gallery.zoomInitialization;
  };

  document.querySelectorAll('media-gallery[data-defer-image-zoom="true"]').forEach((gallery) => {
    const isZoomControl = (event) => event.target.closest('.js-photoswipe--zoom');

    gallery.addEventListener('pointerover', (event) => {
      if (isZoomControl(event)) initialize(gallery);
    }, { passive: true });

    gallery.addEventListener('focusin', (event) => {
      if (isZoomControl(event)) initialize(gallery);
    });

    gallery.addEventListener('click', (event) => {
      const control = isZoomControl(event);
      if (!control || gallery.dataset.zoomInitialized === 'true') return;

      event.preventDefault();
      event.stopImmediatePropagation();
      initialize(gallery).then(() => control.click()).catch(() => {});
    }, true);
  });
})();
